import { useTranslation } from 'react-i18next';

import { styled, Typography } from '@mui/material';

import { Linkify } from 'Common/Linkify';
import { Colors } from 'Themes/colors';
import { useToggle } from 'Utils/customHooks';

import { ArrowDropDownIcon, ArrowDropUpIcon } from '@libs/shared/ui/icons';

const ToggleTypography = styled(Typography)`
  cursor: pointer;
  color: ${Colors.blue} !important;
  font-style: normal;
  display: flex;
  align-items: center;
`;

type Props = {
  value: string | null | undefined;
  shouldShowAllValue?: boolean;
};

const MAX_LENGTH = 200;

export const Description = ({ value, shouldShowAllValue = false }: Readonly<Props>) => {
  const { t } = useTranslation();

  const [more, toggle] = useToggle();

  if (!value) {
    return '';
  }

  if (!shouldShowAllValue && value.length > MAX_LENGTH) {
    return (
      <Typography fontStyle="italic">
        <Linkify>{more && !shouldShowAllValue ? value : value.slice(0, MAX_LENGTH)}</Linkify>
        <ToggleTypography onClick={toggle}>
          {!shouldShowAllValue ? (
            more ? (
              <>
                <ArrowDropUpIcon />
                {t('coursesPage.hideText')}
              </>
            ) : (
              <>
                <ArrowDropDownIcon />
                {t('coursesPage.readMore')}
              </>
            )
          ) : (
            ''
          )}
        </ToggleTypography>
      </Typography>
    );
  }

  return (
    <Typography fontStyle="italic">
      <Linkify>{value}</Linkify>
    </Typography>
  );
};
